var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-profile-card"},[_c('ImageName',{attrs:{"name":_vm.lineProfile.display_name,"src":_vm.lineProfile.profile_image_url,"size":"small"}},[_c('a-icon',{attrs:{"type":"user"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }